/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber7Small = createReactComponent("number-7-small", "IconNumber7Small", [
  ["path", { d: "M10 8h4l-2 8", key: "svg-0" }]
]);

export { IconNumber7Small as default };
//# sourceMappingURL=IconNumber7Small.js.map
